import React, { useEffect, useState } from "react";
import {
  getAmbientState,
  subscribeAmbientState,
} from "./AmbientManager";

// NapflixOS Ambient UI v1
// Passive display only: no focus, no pointer capture, no navigation ownership.
export default function AmbientOverlay() {
  const [ambientState, setAmbientState] = useState(getAmbientState());
  const [clock, setClock] = useState("");

  useEffect(() => {
    setAmbientState(getAmbientState());
    return subscribeAmbientState(setAmbientState);
  }, []);

  useEffect(() => {
    if (!ambientState.active) return undefined;

    const tick = () => {
      setClock(
        new Date().toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        })
      );
    };

    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [ambientState.active]);

  if (!ambientState.active) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483000,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(circle at center, rgba(30, 38, 58, 0.28), rgba(0, 0, 0, 0.86) 68%), linear-gradient(180deg, rgba(0,0,0,0.22), rgba(0,0,0,0.72))",
        color: "rgba(255, 255, 255, 0.92)",
        opacity: 1,
        animation: "napflixAmbientFadeIn 900ms ease forwards",
      }}
    >
      <style>{`
        @keyframes napflixAmbientFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>

      <div style={{ textAlign: "center" }}>
        <div
          style={{
            fontFamily: "'Bebas Neue', 'Arial Narrow', sans-serif",
            fontSize: 92,
            letterSpacing: 1,
            lineHeight: 1,
            textShadow: "0 0 42px rgba(229,160,13,0.2)",
          }}
        >
          {clock}
        </div>
        <div
          style={{
            marginTop: 18,
            fontFamily: "'Outfit', sans-serif",
            fontSize: 15,
            letterSpacing: 3,
            textTransform: "uppercase",
            color: "rgba(229, 199, 93, 0.88)",
          }}
        >
          Napflix Ambient Mode
        </div>
        <div
          style={{
            marginTop: 14,
            fontFamily: "'Outfit', sans-serif",
            fontSize: 12,
            letterSpacing: 2,
            textTransform: "uppercase",
            color: "rgba(255, 255, 255, 0.48)",
          }}
        >
          Press Any Button
        </div>
      </div>
    </div>
  );
}
